// extracted by mini-css-extract-plugin
export default {"ecospendBlock":"pwXtBPgpNI1LRRTkUm_h"};